import React, { PureComponent } from 'react';
import { Route, Switch } from 'react-router-dom';
import asyncComponent from 'util/asyncComponent';
import { Authentication } from 'src/helpers/Authorization';
import Permission from 'src/helpers/Permission';
import PropTypes from 'prop-types';

const HeThong = asyncComponent(() => import('./HeThong'));
const ThongKe = asyncComponent(() => import('./ThongKe'));
const DanhMuc = asyncComponent(() => import('./DanhMuc'));
const HoSo = asyncComponent(() => import('./User/HoSo'));
const QlChiTieu = asyncComponent(() => import('./QLChiTieu'));
const Error401 = asyncComponent(() => import('./CustomViews/401'));
const Home = asyncComponent(() => import('./User/Home'));
const HoTro = asyncComponent(() => import('./HoTro/HoTro'));
export class App extends PureComponent {
  render() {
    const { match, activedVaiTro } = this.props;
    /**
     * Bỏ comment activedVaiTro
     * Đoạn này sử dụng như KHCN
     * Tiến hành extract danh sách activedVaiTro ra dựa theo danh sách trả về mà làm việc
     * Vẫn chưa thể động hoàn toàn
     * Cần bổ sung khai báo component được sử dụng cho vai trò đó mới có thể làm được
     * Nan giải
     * */
    return (
      <div className="gx-main-content-wrapper">
        <Switch>
          <Route
            component={Authentication(HeThong, activedVaiTro, [Permission.ADMIN, Permission.HE_THONG], true)}
            path={`${match.url}he-thong`}
          />
          <Route
            component={Authentication(DanhMuc, activedVaiTro, [Permission.ADMIN, Permission.DANH_MUC], true)}
            path={`${match.url}danh-muc`}
          />
          <Route
            component={Authentication(ThongKe, activedVaiTro, [Permission.ADMIN, Permission.THONG_KE], true)}
            path={`${match.url}thong-ke`}
          />
          <Route
            component={Authentication(QlChiTieu, activedVaiTro, [Permission.ADMIN, Permission.HE_THONG], true)}
            path={`${match.url}quan-ly-bieu-mau`}
          />
          <Route
            component={Authentication(QlChiTieu, activedVaiTro, [Permission.ADMIN, Permission.HE_THONG], true)}
            path={`${match.url}quan-ly-chi-tieu`}
          />
          <Route
            component={Authentication(Error401, activedVaiTro, [Permission.ADMIN], true)}
            path={`${match.url}error/401`}
          />
          <Route component={HoSo} path={`${match.url}user/ho-so`} />
          <Route component={Home} path={`${match.url}user/home`} />
          <Route
            component={
              Authentication(HoTro, activedVaiTro, [
                Permission.XEM, Permission.ADMIN, Permission.NHAP_LIEU,
                Permission.QUAN_LY_THON, Permission.QUAN_LY_XA, Permission.THONG_KE,
                Permission.DANH_MUC, Permission.HE_THONG, Permission.QUAN_LY_CHI_TIEU], true)
            }
            exact
            path={`${match.url}ho-tro`}
          />
        </Switch>
      </div>
    );
  }
}
App.propTypes = {
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  activedVaiTro: PropTypes.objectOf(PropTypes.any).isRequired
};
export default App;
